// Portuguese (Brazil)

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `aberta até ${date}` : ''),
    },
    interview: {
      title: 'Resposta à entrevista em vídeo',
      submit: 'Enviar respostas e completar a entrevista',
      continueLater: 'Continuar mais tarde',
      startInterview: 'Iniciar entrevista',
      duplicateError: 'Você já participou desta entrevista. Você recebeu um e-mail de invitations@recright.com com um link que pode ser usado para continuar a entrevista.',
      confirmSubmitHeader: 'Você não respondeu a todas as perguntas da entrevista',
      confirmSubmitContent: 'Quer mesmo terminar a entrevista?',
      confirmSubmitContentWarning: 'Depois disso, você não pode mais completar suas respostas.',
      submitInterviewHeader: 'Envie suas respostas da entrevista',
      submitInterviewContent: 'Tem certeza de que deseja enviar sua entrevista?',
      confirmSubmitButton: 'Envie respostas e complete a entrevista',
      preview: 'Você pode visualizar as perguntas em vídeo aqui.',
      withdrawLink: 'Não tem mais interesse neste cargo? Saia do processo aqui.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nome',
      city: 'Cidade natal',
      email: 'E-mail',
      phone: 'Número de telefone',
      link: 'Link',
      legendBasicInfo: 'Informações básicas',
      placeholderName: 'Insira seu nome',
      placeholderEmail: 'Insira seu e-mail',
      placeholderPhone: 'Insira seu telefone',
      placeholderCity: 'Insira a cidade em que que reside atualmente',
      placeholderLink: 'Adicione um link, por exemplo, do seu perfil LinkedIn.',
      legendAttachments: 'Anexos',
      legendAdditionalFields: 'Informações adicionais',
      required: 'Os itens marcados com um asterisco * são obrigatórios.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Áudio',
        video: 'Vídeo',
        yes: 'Sim',
        no: 'Não',
        supported: 'Compatível',
        quality: 'Qualidade',
        header: 'Teste de conexão de rede e dispositivo',
        description: 'Agora vamos executar um teste para garantir que sua conexão de rede e o hardware necessário para a entrevista (câmera e telefone) estão funcionando corretamente. Quando solicitado, permita que o teste use sua câmera e microfone e verifique se ela não está coberta. O teste levará cerca de 30 segundos. Recomendamos que você fale durante o teste do hardware.',
        inProgress: 'Teste em andamento...',
        networkTestResults: 'Resultados do teste de rede',
        qualityTestResults: 'Resultados do teste de qualidade',
        testPassedQuality: 'Passou no teste de qualidade',
        testFailedQuality: 'Falha no teste de qualidade',
        testPassedNetwork: 'Êxito no teste de rede',
        testFailedNetwork: 'Falhou no teste de rede',
        startTest: 'Iniciar teste',
        startInterview: 'Iniciar a entrevista',
        testAgain: 'Testar novamente',
        confirmWarning: 'Quando sua entrevista por vídeo iniciar, você será transferido automaticamente para visualizar a primeira pergunta. Em seguida, você será transferido para a preparação.',
        confirmTitle: 'Você está prestes a começar sua entrevista',
        confirmText: 'Você tem pouco tempo para preparar sua resposta antes de cada pergunta. Depois de prepará-la, você tem um tempo predefinido para responder. Note que é possível enviar a resposta assim que você estiver pronto, mesmo antes de o tempo predefinido para a resposta terminar.',
        confirmText2: 'Depois de enviar sua resposta, você passa para a próxima pergunta até que não haja mais perguntas.',
        confirmText3:
          'Observação: depois de gravar sua resposta a uma pergunta, você terá um intervalo de 30 segundos para refazer sua resposta, se for permitido refazer a pergunta. Se você não iniciar uma nova tentativa dentro de 30 segundos, sua resposta atual será automaticamente enviada e você será direcionado para a próxima pergunta.',
        goodLuck: 'Respire fundo e tudo vai dar certo. Boa sorte!',
        qualityRating: {
          excellent: 'Excelente',
          good: 'Bom',
          fair: 'Razoável',
          poor: 'Ruim',
          bad: 'Péssimo',
        },
      },
      questionAnswerView: {
        title: title => `Responder à entrevista ${title}`,
        question: 'Pergunta',
        submitAndNext: 'Enviar e ir para a próxima',
        submitSuccess: 'O vídeo foi enviado!',
        skipText: 'Começar a gravar',
        stop: 'Parar',
        submitAndFinish: 'Enviar e concluir a entrevista',
        retake: 'Repetir',
        take: 'Aceitar entrevista',
        takesLeft: 'Entrevistas restantes',
        skipTextQuestion: 'Tudo pronto? Siga em frente',
        retakeConfirmTitle: 'Tem certeza de que deseja retomar sua resposta para esta pergunta?',
        retakeConfirmSubmit: 'Sim, iniciar retomada',
        submitInfoForward: 'Enviando sua resposta atual automaticamente e avançando em',
        submitInfoForward2: 'segundos',
        nonAnswerableText: 'Esta mensagem não exige resposta. Após esta mensagem, você será encaminhado diretamente para a próxima pergunta.',
        nonAnswerableVideo: 'Este vídeo não exige resposta. Após este vídeo, você será encaminhado diretamente para a próxima pergunta.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Você tem ${answerMinutes} minutos e ${answerSeconds} segundos para responder à pergunta.`,
      },
      publisher: {
        toNextQuestion: timer => `Passando para a próxima pergunta em ${timer}`,
        recordingStarts: timer => `A gravação começa em ${timer}`,
      },
      errors: {
        tooManyConnections: 'Esta conexão foi encerrada porque você já tem uma conexão aberta em outra guia ou janela.',
        unsupportedBrowser: 'Infelizmente, esta operação não é compatível com seu navegador. Use um navegador diferente.',
        networkError: 'Sem conexão com a internet.',
        reconnecting: 'A conexão foi interrompida. Tentando reconectar.',
        generalError: 'Ocorreu um erro. Atualize a página e tente novamente.',
        allowMediaDevicesError: 'Esta operação falhou em obter os dispositivos de mídia (câmera ou microfone). Verifique se você permitiu que o navegador usasse a câmera e o microfone.',
        noAvailableDevicesError: 'Não foi possível encontrar uma câmera ou microfone.',
        initPublisherError: 'A operação falhou devido a um erro. Verifique se você permitiu que o navegador usasse sua câmera e microfone e se eles não estão sendo usados por outro aplicativo. Em seguida, tente novamente.',
      },
      browserInfo: {
        browserSupportTitle: 'Compatibilidade do navegador',
        supportedBrowsers: 'O teste e a entrevista são compatíveis com as versões mais recentes do Chrome, Firefox, Safari e Edge.',
        mobileSupported: 'Navegadores compatíveis em dispositivos móveis',
        android: 'Android: Google Chrome (versão mais recente), Firefox (versão mais recente)',
        iOS: 'iOS: Safari (versão mais recente)',
        latestVersion: 'Verifique se você está usando a versão mais recente do navegador para garantir um bom funcionamento.',
        freezeInstruction: 'Se a gravação de vídeo iniciar ou a tela de gravação continuar preta, atualize a página.',
        unsupportedOnIos: 'Parece que você está usando um navegador incompatível no iOS. Use o Safari.',
        ieUnsupported: 'Parece que você está usando o Internet Explorer. Infelizmente, esse navegador não é compatível com o teste ou a entrevista. Use um navegador diferente.',
        qualityTestNotSupported: 'Infelizmente, o teste de hardware não é compatível com o navegador que você está usando. É possível continuar a entrevista sem testar a qualidade de áudio e de vídeo ou usar um navegador diferente.',
      },
      reconnectSuccess: 'Reconectado!',
      continue: 'Continuar',
    },

    withdraw: {
      title: 'Não tem mais interesse neste cargo?',
      description: 'Saia do processo de recrutamento.',
      buttonText: 'Sair do processo de recrutamento',
      thankYouTitle: 'Obrigado!',
      thankYouText: 'Você acaba de informar os recrutadores de que não tem mais interesse no cargo.',
      confirm: 'Tem certeza de que quer sair do processo de recrutamento? Após sair, você não poderá mais responder a esta ou qualquer entrevista relacionada a este cargo.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Enviar',
      continue: 'Continuar',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Obrigado por sua resposta em vídeo! Entraremos em contato em breve!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Obrigado por participar da entrevista!',
      reopenDescription: 'Caso tenha fechado esta entrevista sem querer, não se preocupe! Você pode abrir a entrevista novamente clicando no botão abaixo!',
      reopenButtonText: 'Reabrir entrevista',
      description1: 'Ótimo, você respondeu a todas as perguntas e elas foram enviadas para o destinatário.',
      descriptionsupport: mailto => `Se você fechou esta entrevista por acidente, entre em contato com o nosso serviço ao cliente ${mailto} e vamos reabrir a sua entrevista.`,
      descriptionfeedback: 'Sua experiência é importante para nós! Como foi a sua experiência ao responder a uma entrevista em vídeo? Como você melhoraria nosso serviço? Deixe seus comentários aqui.',
      feedbackbutton: 'Deixe seus comentários!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Mensagem pessoal',
    },

    closed: {
      title: 'A entrevista foi concluída ou a entrevista terminou',
      description: 'A entrevista em vídeo que você foi convidado para fazer já terminou ou você concluiu o envio.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Sua entrevista em vídeo está salva!',
      description: 'Quando você quiser continuar a entrevista em vídeo, use o link que você recebeu anteriormente por e-mail. As respostas de vídeo já gravadas estarão lá quando você voltar! Boa sorte na busca de emprego!',
      remember: 'Lembre-se de enviar as respostas para o recrutador depois de ter terminado de responder à entrevista.',
      deleteHistory: 'Se você estiver fazendo a entrevista em vídeo em um computador público, lembre-se de limpar o seu histórico de navegação. Dessa forma, sua entrevista estará segura.',
    },
    unpublished: {
      title: 'A entrevista ainda não foi aberta',
      publishTime: publishTime => `A entrevista será aberta ${publishTime}`,
    },
  },
}
